<template>
  <div>
    <form class="create-cat" v-on:submit.prevent="createCat()">
      <input name="title" v-model="name" placeholder="Your Cats Name"/>
      <button type="submit">+</button>
    </form>
    <div class="bad-word" v-if="foundBadWord">
      For shame, detected the word '{{ badWord }}' which isn't allowed.
      <br><small>Cat's have feelings too 😿</small>
    </div>
    <div class="bad-word" v-if="stringTooLong">
      Only names 25 characters or less can be accepted
    </div>
    <div class="social">
      <div style="padding-bottom:0.5%;" class="container fb-like" data-href="https://uniqitty.com" data-layout="button_count" data-action="like" data-show-faces="true" data-share="true"></div>
      <a href="https://twitter.com/share" class="twitter-share-button" data-text="Check out Uniqitty to see if your cat name is unique!" data-url="https://uniqitty.com" data-hashtags="Uniqitty" data-show-count="false">Tweet</a>
    </div>
  </div>
</template>

<script>
  import Firebase from 'firebase';
  import CatRepository from '../../data/CatRepository';

  const firebase = new Firebase('https://uniquitty-10845.firebaseio.com/');

  export default {
    data() {
      return {
        name: '',
        foundBadWord: false,
        stringTooLong: false,
        badWord: ''
      };
    },
    methods: {

      upperCaseFirst(str){
        return str.charAt(0).toUpperCase() + str.substring(1);
      },

      profanityFilter(text) {
        const profanity = [
          'cunt',
          'pussy',
          'whore',
          'arse',
          'asshole',
          'arsehole',
          'wanker',
          'wank',
          'wanking',
          'cock',
          'dick',
          'nigger',
          'chink',
          'jew',
          'fuck',
          'fuckface',
          'fucker',
          'motherfucker',
          'bitch',
          'bastard',
          'clit',
          'fucking',
          'shit',
          'shite',
          'gobshite',
          'choad',
          'tranny',
          'faggot',
          'fag',
          'homo',
          'paki',
          'slitty face',
          'fuk',
          'cocksucker',
          'dicksucker',
          'clitsucker',
          'cum',
          'semen',
          'titties',
          'tits',
          'shoe me dem penguin titties',
          'tit',
          'boobs',
          'boob',
          'bender',
          'clunge',
          'jap',
          'japs eye',
          'penis',
          'shlong',
          'niggerfaggot',
          'bumbaclat',
          'cracker',
          'turk',
          'yank',
          'nazi',
          'bumder',
          'cuntflaps',
          'twat',
          'snatch',
          'http',
          'https',
          ':',
          '.com',
          '.co',
          '/',
          'pussay',
          'cnut',
          'c u n t',
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          '<',
          '>',
          '£',
          '"',
          '\\',
          '\'',
          '!',
          '$',
          '%',
          '^',
          '&',
          '*',
          '(',
          ')',
          '-',
          '_',
          '=',
          '+',
          '#',
          ':',
          ';',
          '@',
          '?',
          '|',
          '¬',
          '`',
          'Kim Jung',
          'Anne Frank',
          'ass',
          'na zi',
          'Hitler',
          'd i c k',
          'test',
          'puss y',
          'p u s s y',
          'of the',
          'Annie Frankie',
          'Princess Annie',
          'sucks',
          'peenis',
          'hitler',
          'peenus',
          'anus',
          'Vos',
          'pu ssy',
          'lmao',
          'penls',
          'satan',
          'bung hole',
          'ashole'
        ];

        var re = new RegExp(' ', 'g');
        for (let word in profanity) {
          if (text.replace(re, '').includes(profanity[word])){
            return {
              containsProfanity: true,
              badWord: profanity[word]
            }
          }
        }

        return {
          containsProfanity: false
        };

      },

      createCat() {
        this.name = this.name.replace(/[^\x00-\x7F]/g, "");
        this.name = this.upperCaseFirst(this.name.toLowerCase());

        if (this.name.trim()) {

          if (this.name.length > 24) {
            this.stringTooLong = true;
            return;
          } else {
            this.stringTooLong = false;
          }

          const profanityCheck = this.profanityFilter(this.name.toLowerCase());

          if (profanityCheck.containsProfanity){
            this.badWord = profanityCheck.badWord;
            this.foundBadWord = true;
            return;
          } else {
            this.foundBadWord = false;
          }

          const newCat = {};

          newCat[this.name] = {
            number: 1,
          };

          const catQuery = `cats/${this.name}`;

          firebase.child(catQuery).once('value', (snapshot) => {
            if (snapshot.exists()) {
              // Update
              CatRepository.update({ snapshot, name: this.name }, (err) => {
                if (err) throw err;
                this.name = '';
              })
            } else {
              CatRepository.create({ name: this.name }, (err) => {
                if (err) throw err;
                this.name = '';
              })
            }
          })

          this.name = '';
        }
      },
    },
  };
</script>

<style>
  form.create-cat{
    position: relative;
    width: 20%;
    margin: 15px auto;
    background: #fff;
    padding: 10px;
    margin-bottom: 2%;
    border-radius: 2px;
    box-shadow: 0 1px 5px #ccc;
  }
  form.create-cat input, form.create-cat textarea{
    width: 100%;
    border: none;
    padding: 4px;
    outline: none;
    font-size: 1rem;
  }
  form.create-cat button{
    position: absolute;
    right: 18px;
    bottom: -18px;
    background: #41b883;
    color: #fff;
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.3);
    cursor: pointer;
    outline: none;
  }
  .bad-word {
    font-size:1rem;
    color: #e23942;
    text-align: center;
    font-family: 'Open Sans';
    margin-bottom: 20px;
  }
  .social {
    display: flex;
    justify-content: center;
  }
  .social > div {
    margin-right: 5px;
  }

  @media(max-width: 980px) {
    form.create-cat {
      width: 60%;
    }
    form.create-cat input, form.create-cat textarea{
      font-size: 2.5rem;
    }
    .bad-word {
      font-size: 2.3rem;
      padding-top:2%;
      padding-bottom: 2%;
    }
    .cool-cats {
      font-size: 1.9rem;
      font-family: Open Sans;
    }
    .social {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// Create.vue?1709b0b8